const handleApiError = (error) => {
  const errorMessage = error?.response?.data?.error?.message;
  const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
  const errorObj = { ...(error?.response?.data?.error || error), message };
  return errorObj;
};

export { handleApiError };
